import { SHGrid, SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";

interface Props {
  numOfItems?: number;
  numOfColumns?: number;
}
export const HeatMapSkeleton = ({
  numOfItems = 4,
  numOfColumns = 7,
}: Props) => {
  const { palette } = useTheme();

  return (
    <SHStack border={`1px solid ${palette.divider}`} padding={2} gap={4}>
      <SHStack direction={"row"} width={"100%"}>
        <SHStack gap={1} width={"70%"}>
          <SHSkeleton width={"40%"} height={20} delay={false} />
          <SHSkeleton width={"20%"} height={20} delay={false} />
        </SHStack>

        <SHStack
          width={"30%"}
          alignItems={"flex-end"}
          justifyContent={"center"}
        >
          <SHSkeleton
            width={"80px"}
            height={35}
            delay={false}
            sx={{ borderRadius: "100px" }}
          />
        </SHStack>
      </SHStack>

      <SHStack gap={2}>
        <SHStack direction={"row"} width={"100%"}>
          <SHStack width={35} height={"100%"}>
            <SHSkeleton width={20} height={150} delay={false} />
          </SHStack>

          <SHGrid container columns={7} rowGap={0.5} flex={1}>
            {Array.from({ length: numOfItems + 2 }).map((_, rowIndex) => {
              const isFirstRow = rowIndex === 0;
              const isLastRow = rowIndex === numOfItems + 1;

              return (
                <SHStack key={rowIndex} width={"100%"} direction={"row"}>
                  {Array.from({ length: numOfColumns + 1 }).map(
                    (_, colIndex) => {
                      const isFirstColumn = colIndex === 0;
                      return (
                        <SHGrid
                          key={colIndex}
                          width={isFirstColumn ? "calc(20%)" : "calc(80% / 6)"}
                          height={isFirstRow || isLastRow ? 35 : 50}
                        >
                          {isFirstRow || isLastRow ? (
                            <>
                              {isFirstColumn ? (
                                <></>
                              ) : (
                                <SHStack
                                  height={"100%"}
                                  alignItems={
                                    colIndex === 1
                                      ? "flex-start"
                                      : colIndex === 6
                                      ? "flex-end"
                                      : "center"
                                  }
                                >
                                  <SHStack
                                    width={"100%"}
                                    gap={0.5}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                  >
                                    <SHSkeleton
                                      width={"70%"}
                                      height={15}
                                      delay={false}
                                    />
                                    <SHSkeleton
                                      width={"50%"}
                                      height={15}
                                      delay={false}
                                    />
                                  </SHStack>
                                </SHStack>
                              )}
                            </>
                          ) : (
                            <>
                              {isFirstColumn ? (
                                <SHStack
                                  direction={"row"}
                                  width={"100%"}
                                  height={"100%"}
                                  gap={2}
                                  alignItems={"center"}
                                  justifyContent={"center"}
                                >
                                  <SHSkeleton
                                    width={33}
                                    height={33}
                                    delay={false}
                                  />
                                  <SHStack
                                    gap={0.5}
                                    flexGrow={1}
                                    height={"100%"}
                                    alignItems={"flex-start"}
                                    justifyContent={"center"}
                                  >
                                    <SHSkeleton
                                      width={"80%"}
                                      height={18}
                                      delay={false}
                                    />
                                    <SHSkeleton
                                      width={"60%"}
                                      height={18}
                                      delay={false}
                                    />
                                  </SHStack>
                                </SHStack>
                              ) : (
                                <SHStack
                                  height={"100%"}
                                  alignItems={
                                    colIndex === 1
                                      ? "flex-start"
                                      : colIndex === numOfItems
                                      ? "flex-end"
                                      : "center"
                                  }
                                >
                                  <SHSkeleton
                                    width={"95%"}
                                    height={"100%"}
                                    delay={false}
                                  />
                                </SHStack>
                              )}
                            </>
                          )}
                        </SHGrid>
                      );
                    },
                  )}
                </SHStack>
              );
            })}
          </SHGrid>
        </SHStack>

        <SHStack
          direction={"row"}
          width={"100%"}
          justifyContent={"space-between"}
        >
          <SHSkeleton width={"20%"} height={18} delay={false} />
          <SHSkeleton width={"100px"} height={20} delay={false} />
        </SHStack>
      </SHStack>
    </SHStack>
  );
};
